import { GlitchPass } from 'three/examples/jsm/postprocessing/GlitchPass.js';
import {UnrealBloomPass} from 'three/examples/jsm/postprocessing/UnrealBloomPass';
import AudioPlayer from "./audio/audioPlayer";

//Entity
import Bridge from "./entities/bridge";
import Car from "./entities/car";
import Ground from "./entities/ground";
import Player from "./entities/player";
import Road from "./entities/road";
import Tower from "./entities/tower";
import MAD from "./mad-engine";
import NoiseReader from "./utils/noiseReader";

window.onload = () => {
    createApp();
    createGame();
}


function createApp(){
    const postprocessing = {
        bloom: new UnrealBloomPass( new THREE.Vector2( window.innerWidth, window.innerHeight ), 0.8, 0.2, 0.2 ),
        glitch: new GlitchPass()
    };
    postprocessing.glitch.goWild = true;
    postprocessing.glitch.enabled = false;

    const app = new MAD.App({
        postprocessing
    });
}

function createGame(){

    const audio = new AudioPlayer("music.mp3");
    const noise = new NoiseReader(audio);
    MAD.STORE.set("noise", noise);
    const test = new Road();
    const ground = new Ground();
    const player = new Player();
    MAD.STORE.set("player", new Player());
    for(let i = 0; i< 50; i++){
        const tower = new Tower();
    }
    for(let i = 0; i< 5; i++){
        const b = new Bridge();
    }
    const cars = [];
    for(let i = 0; i< 30; i++){
        const car = new Car();
        cars.push(car);
    }
    MAD.STORE.set("cars", cars);

    document.addEventListener("click", () =>{
        if(!audio.isReady) return;
        noise.start();
    });
}